import type { ComponentProps } from "react"
import { Sheet as SheetBase } from "@/v2-ui/sheet/base/SheetBase"

export type SheetProps = ComponentProps<typeof SheetBase> & {
  modal?: boolean
}

function Sheet(props: SheetProps) {
  const { modal, ...sheetBaseProps } = props
  return <SheetBase modal={modal} {...sheetBaseProps} />
}

export default Sheet
